module.exports = __webpack_public_path__ + "img/s11Model1.65861cd6.webp";